(() => {
  // Hero interaction layer (UI motion only; the imagery is Codex stills / Seedance video).
  // Desktop: pointer depth parallax + hover lift. Both: scroll drift, rotor cue, play-in-view.
  const stage = document.querySelector('.ww-hx__stage');
  if (!stage) return;
  const host = document.querySelector('[data-ww-rotor-host]');
  const photo = stage.querySelector('.ww-hx__photo');
  const floats = [...stage.querySelectorAll('.ww-hx__float')];
  const videos = [...stage.querySelectorAll('.ww-hx__float video')];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = false; // pointer parallax off (Mert 2026-09-25: mouse-follow felt odd); hero composition is being redesigned

  // Play videos only while the hero is on screen (battery + CPU on phones).
  if ('IntersectionObserver' in window && videos.length) {
    new IntersectionObserver((es) => es.forEach((e) => {
      videos.forEach((v) => { if (e.isIntersecting && !reduce) { const p = v.play(); if (p) p.catch(() => {}); } else v.pause(); });
    }), { threshold: 0.15 }).observe(stage);
  }
  if (reduce) { videos.forEach((v) => { v.removeAttribute('autoplay'); v.pause(); }); return; }

  // Rotor cue: "days" belongs to the evening bottle, the morning words to the morning bottle.
  if (host) host.addEventListener('ww:rotor', (e) => {
    const w = e.detail && e.detail.word;
    const target = stage.querySelector(w === 'days' ? '.ww-hx__float--pm' : '.ww-hx__float--am');
    if (!target) return;
    target.classList.remove('is-cue'); void target.offsetWidth; target.classList.add('is-cue');
  });

  // Pointer depth (desktop only) + scroll drift (all), eased on one rAF loop.
  let px = 0, py = 0, tx = 0, ty = 0, scroll = 0, raf = 0;
  const depth = { am: [22, 14, 3], pm: [-26, 16, -3] };
  const tick = () => {
    px += (tx - px) * 0.08; py += (ty - py) * 0.08;
    const r = stage.getBoundingClientRect();
    scroll = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height)));
    if (photo) photo.style.translate = `${(-px * 8).toFixed(2)}px ${(-py * 6 + scroll * 40).toFixed(2)}px`; // the CSS transform already centres it
    floats.forEach((f) => {
      const d = f.classList.contains('ww-hx__float--pm') ? depth.pm : depth.am;
      const side = f.classList.contains('ww-hx__float--pm') ? 1 : -1;
      f.style.setProperty('--fx', `${(px * d[0] + side * scroll * 60).toFixed(2)}px`);
      f.style.setProperty('--fy', `${(py * d[1] - scroll * 90).toFixed(2)}px`);
      f.style.setProperty('--fr', `${(px * d[2]).toFixed(2)}deg`);
    });
    raf = (Math.abs(tx - px) > 0.001 || Math.abs(ty - py) > 0.001) ? requestAnimationFrame(tick) : 0;
  };
  const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };
  if (fine) {
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2; ty = ((e.clientY - r.top) / r.height - 0.5) * 2; kick();
    });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; kick(); });
  }
  const scroller = document.querySelector('.page-wrapper');
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; tick(); }); };
  window.addEventListener('scroll', onScroll, { passive: true });
  if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  tick();
})();
